import { Box, Button } from '@mantine/core';
import { IconExternalLink, IconLock } from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import TabHeader from './TabHeader';
import { useFlags } from 'src/feature-flags/FlagsHook';
import Config from 'src/common/Config';

export default function PasswordManagement() {
  const { flagEnabledCustomSettingsFlow } = useFlags();

  return (
    <Box>
      <TabHeader
        title="Password & Security"
        subtitle="Manage your password, email, and multi-factor authentication."
      />

      {flagEnabledCustomSettingsFlow ? (
        <Button
          component={Link}
          to="/settings"
          target="_blank"
          leftSection={<IconLock size={14} />}
          mt="md"
        >
          Manage Credentials
        </Button>
      ) : (
        <Button
          component="a"
          href={Config.getOrySettingsUrl()}
          target="_blank"
          rel="noopener noreferrer"
          leftSection={<IconExternalLink size={14} />}
          mt="md"
        >
          Manage Credentials on Secure Page
        </Button>
      )}
    </Box>
  );
}
